// test1520
(1520 && 0);
